<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1100"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="划拨"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 15 }"
          @submit="handleSubmit"
        >
          <a-col :span="12">
            <a-form-item :wrapper-col="{ span: 24 }">
              <common-module-input
                :rows="20"
                @change="handleModulesChange"
                v-decorator="['modules', {
                  rules: [{ validator: checkModules }],
                }]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="项目模组数(片)">
              <span>{{ data.item_cards_count }}</span>
            </a-form-item>

            <a-form-item label="已划拨模组数(片)">
              <span>{{ data.allocated_cards_count }}</span>
            </a-form-item>

            <a-form-item label="输入模组总数(片)">
              <span>{{ input_modules_count }}</span>
            </a-form-item>

            <a-form-item label="备注">
              <a-textarea
                :rows="3"
                v-decorator="['remark', {
                  rules: [
                    { max: 200, message: '最多200个字符' },
                  ]
                }]"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { allocateModulesToTopAgent, findAgentPurchaseItemAllocationInfo } from '@/api/agent_purchase_item'
import CommonModuleInput from '@/components/ModuleInput/Common'

export default {
  name: 'AllocateModulesToTopAgent',
  components: { CommonModuleInput },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    agentPurchaseItemId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {
        item_cards_count: 0,
        allocated_cards_count: 0
      },
      input_modules_count: 0,
      form: this.$form.createForm(this, { name: 'allocate_modules' }),
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findAgentPurchaseItemAllocationInfo(this.agentPurchaseItemId).then((res) => {
        if (res.code === 0) {
          this.data = res.data
        }
      })
    },

    checkModules(rule, value, callback) {
      if (!value || !value.inputValue) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入模组信息')
        return
      }

      if (value.validateStatus === 'error') {
        callback(value.errorMsg)
        return
      }

      if (this.input_modules_count + this.data.allocated_cards_count > this.data.item_cards_count) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('模组数量超过项目要求')
        return
      }

      // eslint-disable-next-line standard/no-callback-literal
      callback()
    },

    handleModulesChange(e) {
      this.input_modules_count = e.modulesCount - e.duplicateModulesCount
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (err) return

        const imeis = (values.modules.data || []).map((item) => item.imei).filter((imei) => imei)
        if (imeis.length === 0) {
          this.$warning({ title: '请输入有效 IMEI' })
          return
        }

        this.submitting = true
        allocateModulesToTopAgent(this.agentPurchaseItemId, {
          imeis,
          remark: values.remark
        }).then((res) => {
          this.submitting = false
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
            this.$success({
              title: '提交成功',
              content: (
                <div>
                  <p>操作成功，具体操作结果请至 【系统查询】-【批量操作查询】 查看</p>
                </div>
              )
            })
          }
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>
